import { List as ImList, OrderedMap } from 'immutable';

import { accountsUtils, accountsSelectors } from 'companion-app-components/flux/accounts';
import type { CashFlowTransaction } from 'companion-app-components/flux/transactions/transactionsTypes';
import { transactionsUtils } from 'companion-app-components/flux/transactions';
import { chartOfAccountsTypes } from 'companion-app-components/flux/chart-of-accounts';
import { deriveAccountGroupdIds } from 'companion-app-components/flux/account-groups/accountGroupUtils';
import { AccountGroup } from 'companion-app-components/flux/account-groups/accountGroupsTypes';

import store from 'store';
import { filterByKeys } from 'utils/utils';
import * as transactionsConfig from './transactionsConfig';

export const newRegFields = (doubleAmounts) => {
  const objTxnConfig = transactionsConfig.fieldData;
  const editables = Object.keys(filterByKeys(objTxnConfig, (config) => config.editable));
  if (doubleAmounts) {
    editables.splice(editables.indexOf('amount'), 1);
  } else {  
    editables.splice(editables.indexOf('income'), 1);
    editables.splice(editables.indexOf('expense'), 1);
  }

  return ImList(editables);
};

export const txnListHasAttachment = (
  txnMap: OrderedMap<string, ImList<CashFlowTransaction>>,
  txnBeingEdited?: CashFlowTransaction,
) => {
  let foundAttachment: undefined | boolean | CashFlowTransaction = false;
  if (txnBeingEdited && txnBeingEdited.attachments && txnBeingEdited.attachments.length > 0) {
    return true;
  }
  if (txnMap) {
    txnMap.keySeq().forEach((key) => {
      const txnMapKey = txnMap.get(key);
      if (!foundAttachment && txnMapKey) {
        foundAttachment = txnMapKey.find((txn) => (Boolean(txn.attachments && txn.attachments.length > 0)));
      }
    });
  }

  return foundAttachment;
};

export const firstBankAccount = (accountIds) => {
  const ret = accountIds.filter((id) =>
    !(accountsUtils.isLoanAccount(accountsSelectors.getAccountById(store.getState(), id))
      || accountsUtils.isInvestmentAccount(accountsSelectors.getAccountById(store.getState(), id))));

  const sorted = ret.sort((objAccount1, objAccount2) => {
    // @ts-expect-error - FIXME: Expected 2 arguments, but got 1.ts(2554)
    if (accountsUtils.isBankAccountFromId(objAccount1)) {
      // @ts-expect-error - FIXME: Expected 2 arguments, but got 1.ts(2554)
      return accountsUtils.isBankAccountFromId(objAccount2) ? 0 : -1;
    }
    // @ts-expect-error - FIXME: Expected 2 arguments, but got 1.ts(2554)
    return accountsUtils.isBankAccountFromId(objAccount2) ? 1 : 0;
  });

  return sorted.first();
};

export const isTransferAccountAvailable = (txn, isEntityGroupEnabledUser, accountsById) => {
  if (!transactionsUtils.isTransferTxn(txn) || !isEntityGroupEnabledUser) {
    return true;
  }
  const coaIds: string[] = (() => {
    if (transactionsUtils.isSplitTxn(txn)) {
      const splitItems = txn?.split?.items ?? [];
      return splitItems
        .map((split) => split?.coa)
        .filter((coa: chartOfAccountsTypes.ChartOfAccountProps) => !!coa && coa.type === chartOfAccountsTypes.CoaTypeEnum.ACCOUNT)
        .map((coa) => coa.id!);
    }
    const coa = txn?.coa;
    if (coa?.type === chartOfAccountsTypes.CoaTypeEnum.ACCOUNT && coa.id) {
      return [coa.id];
    }
    return [];
  })();
  if (coaIds.length === 0) {
    return false;
  }
  return coaIds.some((id) => Boolean(accountsById.get(id)));
};

export const hasWriteAccessForAccountById = (_accountsById, isEntitySharedUser, currentDataset, accountGroups, accountId) => {
  if (!isEntitySharedUser) {
    return true;
  }

  const writeGroupIds = deriveAccountGroupdIds(
    currentDataset.itemAccessControl?.resources?.ACCOUNT_GROUP,
    ['write'],
  );

  const writeAccountIds = accountGroups?.filter((accountGroup: AccountGroup) =>
    writeGroupIds.includes(accountGroup.id)).flatMap((accountGroup: AccountGroup) => accountGroup.accountIds);
  return writeAccountIds.includes(accountId);
};
